import { render, staticRenderFns } from "./Maxwhitlock.vue?vue&type=template&id=4d6c5677&scoped=true&"
import script from "./Maxwhitlock.vue?vue&type=script&lang=js&"
export * from "./Maxwhitlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6c5677",
  null
  
)

export default component.exports